<script>

    import { toast } from 'bulma-toast'
    import { orderLinkStore } from '../stores'

    import OrdersLinksService from '../$services/orders.links.service'
    import OrdersService from '../$services/orders.service'
    import ConfigsService from '../$services/configs.service'

    import LocationsComponent from '../locations/component.delivery.link.svelte'
    import QuotationsComponent from '../quotations/component.quotations.link.svelte'
    import ShipmentComponent from '../orders/component.shipment.create.link.svelte'

    import VolumetricPopup from '../$popups/popup.volumetric.weight.svelte'
    import ValuePopup from '../$popups/popup.declared.value.svelte'
    import FrequencyPopup from '../$popups/popup.delivery.frequency.svelte'

    import Container from '../$layouts/container.layout.svelte'

    export let params = {}

    let data = {quotation: {}}
    let order
    let delivery = {}
    let quotation
    let step = 'delivery'
    let configLink
    let loading = false

    let isSuccess = false

    if(params.ordersLinksId)
        getOrderLink()

    async function getOrderLink() {

        loading = true
        const resp = await OrdersLinksService.getOrderLink(params.ordersLinksId)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        orderLinkStore.set(resp.data)
        getConfigLink()
    }

    async function getConfigLink() {

        loading = true
        const resp = await ConfigsService.getConfigLink($orderLinkStore.userId)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        configLink = resp.data
    }

    async function createOrder() {

        data.userId = $orderLinkStore.userId
        data.pickup = $orderLinkStore.pickup
        data.delivery = delivery
        data.package = $orderLinkStore.package
        data.quotation = quotation || {}

        if($orderLinkStore.quotation === 'user' || ($orderLinkStore.quotation === 'client' && $orderLinkStore.payment === 'user'))
            data.quotation.payment = 'notrequired'

        if($orderLinkStore.quotation === 'client' && $orderLinkStore.payment === 'client')
            data.quotation.payment = 'peding'

        const queryData = {
            requestAccess: $orderLinkStore.userId
        }

        loading = true
        const resp = await OrdersService.createOrder(data, queryData)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        order = resp.data
        isSuccess = true

        updateOrderLink()
    }

    async function updateOrderLink() {

        const updateData = {
            userId: $orderLinkStore.userId,
            success: true
        }

        const queryData = {
            requestAccess: $orderLinkStore.userId
        }

        loading = true
        const resp = await OrdersLinksService.updateOrderLink($orderLinkStore._id, updateData, queryData)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        orderLinkStore.set(resp.data)
        toast({message: 'Información guardada', type: 'is-success'})
    }

    function onDeliverySelected() {

        if($orderLinkStore.quotation === 'user')
            createOrder()

        else if($orderLinkStore.quotation === 'client')
            step = 'quotation'
    }

    function onQuotationSelected() {

        if($orderLinkStore.quotation === 'client' && $orderLinkStore.payment === 'user')
            createOrder()

        else if($orderLinkStore.quotation === 'client' && $orderLinkStore.payment === 'client') {
            createOrder()
            step = 'paid'
        }
    }

    function setStep(event) {
        step = event.detail || event
    }

</script>

<VolumetricPopup />
<ValuePopup />
<FrequencyPopup />

{#if configLink && configLink.brand}
    <div class="center">
        <img src="{configLink.brand}" alt="Brand">
    </div>
{:else}
    <div class="hero is-primary">
        <div class="hero-body">
            <div class="container">
                <div class="title">TIL</div>
                <div class="subtitle">SmartLink</div>
            </div>
        </div>
    </div>
{/if}

<Container>
    {#if $orderLinkStore}
        <div class="columns">
            <div class="column">
                <div class="items-end">

                    {#if configLink && configLink.facebook}
                        <a href="{configLink.facebook}" target="_blank" style="color: #363636;">
                            <span class="icon is-large"><i class="fab fa-2x fa-facebook-square"></i></span>
                        </a>
                    {/if}
                    {#if configLink && configLink.instagram}
                        <a href="{configLink.instagram}" target="_blank" style="color: #363636;">
                            <span class="icon is-large"><i class="fab fa-2x fa-instagram"></i></span>
                        </a>
                    {/if}
                    {#if configLink && configLink.pinterest}
                        <a href="{configLink.pinterest}" target="_blank" style="color: #363636;">
                            <span class="icon is-large"><i class="fab fa-2x fa-pinterest"></i></span>
                        </a>
                    {/if}
                    {#if configLink && configLink.webpage}
                        <a href="{configLink.webpage}" target="_blank" style="color: #363636;">
                            <span class="icon is-large"><i class="fas fa-2x fa-globe"></i></span>
                        </a>
                    {/if}
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                {#if step === 'delivery' && isSuccess === false}
                    <LocationsComponent bind:delivery={delivery} on:selected={onDeliverySelected} />
                {/if}

                {#if step === 'quotation' && isSuccess === false}
                    <QuotationsComponent {delivery} requestAccess={$orderLinkStore.userId} bind:quotation={quotation} on:selected={onQuotationSelected} />
                {/if}

                {#if step === 'paid' &&  isSuccess === true}
                    <ShipmentComponent {delivery} {quotation} requestAccess={$orderLinkStore.userId} orderId={order._id} on:step={setStep} />
                {/if}

                {#if step != 'paid' && isSuccess === true}
                    <div class="center">
                        {#if configLink && configLink.message}
                            <div class="title">{ configLink.message }</div>
                        {:else}
                            <div class="title">Tu Información ha sido guardada 😉</div>
                        {/if}
                    </div>
                {/if}
            </div>
            {#if configLink && configLink.banner}
                <div class="column">
                    <div class="center">
                        <a href="{configLink.bannerURL}" target="_blank">
                            <img src="{configLink.banner}" alt="Banner">
                        </a>
                    </div>
                </div>
            {/if}
        </div>
    {/if}

</Container>